import type { GridColDef } from '@mui/x-data-grid';
import type { GridApiCommunity } from '@mui/x-data-grid/internals';
import type { PlanOverview } from '@vy/api-definition';
import { PLAN_STATUSES } from '@vy/types';
import cn from 'classnames';
import type { MutableRefObject } from 'react';
import type { FieldPath } from 'react-hook-form';
import { getPlanDurationLabel } from '../../utils';
import { PlanDotMenu } from '../plans-page-components/PlanDotMenu/PlanDotMenu';

const PLANS_OVERVIEWS_COLUMNS_KEYS = Object.freeze({
  STATUS: 'status',
  NAME: 'name',
  REVENUE: 'revenue',
  TYPE: 'paymentTerm',
  CUSTOMERS: 'customersCount',
  BILLING_INTERVAL: 'billingInterval',
  PLAN_DURATION: 'planDuration',
} satisfies Record<string, FieldPath<PlanOverview>>);

export const getPlansOverviewsColumns = (
  refetchFunction: () => void,
  apiGridRef: MutableRefObject<GridApiCommunity>,
): GridColDef<PlanOverview>[] => [
  {
    field: PLANS_OVERVIEWS_COLUMNS_KEYS.STATUS,
    headerName: 'Status',
    minWidth: 140,
    headerClassName: 'pl-7',
    cellClassName: 'pl-6',
    renderCell: ({ row }) => {
      return (
        <div className="relative flex items-center font-medium uppercase">
          <span
            className={cn(
              'font-sans rounded-2lg px-2 py-1',
              {
                'bg-[#EBFFEF] text-[#4FBA80]': row.status === PLAN_STATUSES.Active,
              },
              {
                'bg-[#EBFFEF] text-[#DC4F79]': row.status === PLAN_STATUSES.Error,
              },
              {
                'bg-[#FFF7F7] text-inactive': row.status === PLAN_STATUSES.Inactive,
              },
            )}
          >
            {row.status}
          </span>
        </div>
      );
    },
  },
  {
    field: PLANS_OVERVIEWS_COLUMNS_KEYS.NAME,
    headerName: 'Name',
    flex: 1,
    renderCell: ({ row }) => <span className="font-sans text-black">{row.name}</span>,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: PLANS_OVERVIEWS_COLUMNS_KEYS.PLAN_DURATION,
    headerName: 'Duration',
    flex: 1,
    headerAlign: 'center',
    align: 'center',
    sortable: false,
    renderCell: ({ row }) => (
      <span className="font-sans text-black">{getPlanDurationLabel(row.planDuration)}</span>
    ),
  },
  {
    field: PLANS_OVERVIEWS_COLUMNS_KEYS.CUSTOMERS,
    headerName: 'Customers',
    flex: 1,
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    field: 'actionMenu',
    headerName: '',
    width: 30,
    sortable: false,
    filterable: false,
    headerClassName: 'bg-white',
    cellClassName: 'bg-white',
    renderCell: ({ row }) => (
      <PlanDotMenu refetchFunction={refetchFunction} plan={row} apiGridRef={apiGridRef} rowId={row.id} />
    ),
  },
];
